(() => {
  const header = document.querySelector('[data-cosmo-header]');
  const drawer = document.querySelector('[data-cosmo-menu]');
  if (!header || !(drawer instanceof HTMLDialogElement)) return;
  const openButton = document.querySelector('[data-cosmo-menu-open]');
  const closeButton = drawer.querySelector('[data-cosmo-menu-close]');
  const searchButton = drawer.querySelector('[data-cosmo-drawer-search]');
  const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
  const closeDrawer = () => { if (drawer.open) drawer.close(); };
  openButton?.addEventListener('click', () => drawer.showModal());
  closeButton?.addEventListener('click', closeDrawer);
  searchButton?.addEventListener('click', closeDrawer);
  drawer.addEventListener('click', (event) => { if (event.target === drawer) closeDrawer(); });
  drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeDrawer));
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
})();
